import { idGenerator } from '@/services';
import { NewConnectionCmhState } from '@/store/new-connection-cmh/types';
import { MutationTree } from 'vuex';

export const mutations: MutationTree<NewConnectionCmhState> = {
  STORE(state, requestId: string) {
    state.requestId = requestId
  },
  RESET(state) {
    state.requestId = idGenerator.getNewWebReference()
    state.totalPrice = null
  },
  STORE_TOTAL_PRICE(state, totalPrice: number | null) {
    state.totalPrice = totalPrice
  }
}

